import { getAmplitudeTestTags, setAmplitudeTestTags } from 'chairisher/context/abtest';
import { isEmptyObject } from 'chairisher/util/type';

/**
 * List of the currently active ab test classes.
 */
const activeABTests = [];

/**
 * Enum mapping the ab test experiment names to their respective ab test class
 *
 * @enum
 * @example testNameToTestClassMap = { 'EXAMPLE_TEST': ExampleTest }
 */
const testNameToTestClassMap = activeABTests.reduce(
    (result, cls) => ({ ...result, [cls.getExperimentName()]: cls }),
    {},
);

/**
 * Runs AB tests
 *
 * @param {Array.<Object>} data
 */
export default function runABTests(data) {
    const amplitudeTestTags = getAmplitudeTestTags();

    data.forEach((testObj) => {
        if (testObj && !isEmptyObject(testObj)) {
            const { amplitude_test_tag: tag, experiment_bucket: bucketNumber, experiment_name: testName } = testObj;
            if (tag && !amplitudeTestTags.includes(tag)) {
                amplitudeTestTags.push(tag);
            }

            const ABTestClass = testNameToTestClassMap[testName];
            if (ABTestClass) {
                new ABTestClass({ bucketNumber }).execute();
            }
        }
    });

    setAmplitudeTestTags(amplitudeTestTags);
}
